import React from 'react';
import MainPage from './components/MainPage'
import NewVersion from './components/NewVersion'
import ConnectedStatus from './components/ConnectedStatus'
require('./utils/rewriteGetElements')

export default () => (
  <div style={{ height: '100%' }}>
    {/*<NavBar />*/}
    <div style={{ height: '100%' }}>
      <ConnectedStatus />
      <NewVersion />
      <MainPage />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/App.js